import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Layout } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import Iframe from '../QuickUpdate/components/Iframe.components'
import { REACT_APP_URL } from '../../config/env'

const Container = styled.div``

const EditProjectMain = () => {
  const history = useHistory()
  const location = useLocation()
  const { id } = useParams()
  const returnTo =
    new URLSearchParams(location.search).get('returnTo') || 'gantt'

  const goBackAfterClose = (target = returnTo) => {
    localStorage.setItem(
      'activeProjectTab',
      target === 'project-card' ? '2' : '1',
    )
    history.push('/project-list')
  }

  useEffect(() => {
    const getExpectedOrigin = () => {
      try {
        return new URL(REACT_APP_URL).origin
      } catch {
        return String(REACT_APP_URL || '').replace(/\/$/, '')
      }
    }

    const openUrlFromExternal = (event) => {
      if (event.origin !== getExpectedOrigin()) return
      if (event.data.action === 'openHelpdeskInApp') {
        window.open(`${REACT_APP_URL}/helpdesk`, '_self')
      }
      if (
        event.data.action === 'closeCreateProject' ||
        event.data.action === 'closeProjectForm'
      ) {
        goBackAfterClose(event.data.returnTo || returnTo)
      }
    }
    window.addEventListener('message', openUrlFromExternal)
    return () => window.removeEventListener('message', openUrlFromExternal)
  }, [history, returnTo])

  return (
    <Container className="main-container">
      <Helmet>
        <title>AXONS PROJECT | Edit Project</title>
      </Helmet>
      <div className="BreadCrumb ">
        <h4 className="level1" onClick={() => goBackAfterClose()}>
          Project
        </h4>
        <RightOutlined className="icon-style" style={{ marginTop: -6 }} />
        <h4
          className="level2 cutter-text-line-1 "
          style={{ minHeight: 28, maxWidth: '60%' }}
        >
          Edit Project
        </h4>
      </div>
      <Layout className="layout-overview">
        <Iframe
          source={`${REACT_APP_URL}/v2/project/${id}?from=${returnTo}`}
        />
      </Layout>
    </Container>
  )
}

export default EditProjectMain
